import { useQuery } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { analyticsKeys } from '../analytics.keys';
import { getClaimedQuestsStatusCount } from '../analytics.service';
import { FiveMinutes, InitialRetryDelay } from '../constants';
export const useClaimedQuestsStatusCount = ({ subdomain = getSubdomain(), startDate, endDate, ...options }) => {
    const q = useQuery({
        refetchInterval: query => (!query.state.data?.isComputed ? InitialRetryDelay : false),
        ...options,
        queryKey: analyticsKeys.claimedQuestsStatusCount(subdomain, startDate, endDate),
        queryFn: () => getClaimedQuestsStatusCount(subdomain, startDate, endDate),
        staleTime: FiveMinutes,
    });
    return { ...q, isPending: q.isPending || !q.data?.isComputed };
};
